// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../assets/checkbox-circle.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SubscriptionMain_title__EDP3Z {
  width: 110%;
  margin: 0 auto 28px;
}

.SubscriptionMain_cards__8FTgc {
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
}

.SubscriptionMain_price__h8ZeZ {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 20px;
  border-radius: 12px;
  background: #4343ff;
  color: #fff;
}
.SubscriptionMain_price-description__dt5mj {
  font-weight: 400;
  font-size: 20px;
  line-height: 36px;
}
.SubscriptionMain_price-month__FK4Lu {
  position: relative;
  font-weight: 400;
  font-size: 28px;
  line-height: 48px;
}
.SubscriptionMain_price-month__FK4Lu span {
  font-weight: 600;
  font-size: 52px;
  line-height: 84px;
}
.SubscriptionMain_price-month__FK4Lu .SubscriptionMain_star-left__Sp8AR {
  position: absolute;
  left: -20px;
  top: 14px;
}
.SubscriptionMain_price-month__FK4Lu .SubscriptionMain_star-right__xVZur {
  position: absolute;
  right: -25px;
  top: 27px;
}
.SubscriptionMain_price-month__FK4Lu .SubscriptionMain_star-small__oWSCZ {
  position: absolute;
  transform: scale(0.4);
  right: -31px;
  top: 38px;
}
.SubscriptionMain_price-year__fiFDf {
  font-weight: 300;
  font-size: 14px;
  line-height: 24px;
}

.SubscriptionMain_product__kemGf {
  padding: 20px;
  border-radius: 12px;
  background: #fff;
  color: #00007a;
}
.SubscriptionMain_product-title__9WmQj {
  margin-bottom: 12px;
  font-weight: 400;
  font-size: 20px;
  line-height: 36px;
}
.SubscriptionMain_product-description__B-ks\\+ {
  font-weight: 300;
  font-size: 16px;
  line-height: 28px;
}

.SubscriptionMain_logo__3mH52 {
  margin-right: 8px;
}

.SubscriptionMain_collapsible-card__iIVJt {
  padding: 20px;
  background: #fff;
}

.SubscriptionMain_list__MOunc {
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-weight: 300;
  font-size: 16px;
  line-height: 28px;
}
.SubscriptionMain_list-title__EysMS {
  font-weight: 400;
  font-size: 20px;
  line-height: 36px;
  color: #00007a;
}

.SubscriptionMain_item__y8rMH {
  display: flex;
  align-items: baseline;
}
.SubscriptionMain_item__y8rMH:before {
  content: "";
  display: inline-block;
  width: 17px;
  min-width: 17px;
  height: 17px;
  margin-right: 10px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  vertical-align: top;
  transform: translateY(4px);
}

.SubscriptionMain_button__V\\+pe6 {
  margin: 40px 0;
  padding: 0 24px;
}

.SubscriptionMain_link__Qe5km {
  width: 360px;
  text-align: center;
  font-weight: 300;
  font-size: 16px;
  line-height: 28px;
  color: #000078;
}

@media screen and (max-width: 600px) {
  .SubscriptionMain_title__EDP3Z {
    width: 100%;
  }
  .SubscriptionMain_button__V\\+pe6 {
    margin: 32px 0 24px;
  }
  .SubscriptionMain_link__Qe5km {
    width: 100%;
    text-align: initial;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Subscription/SubscriptionMain/SubscriptionMain.module.scss","webpack://./src/styles/colors.scss"],"names":[],"mappings":"AAGA;EACE,WAAA;EACA,mBAAA;AAIF;;AADA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,WAAA;AAIF;;AADA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBCnBS;EDoBT,WAAA;AAIF;AAFE;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;AAIJ;AADE;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AAGJ;AADI;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;AAGN;AAAI;EACE,kBAAA;EACA,WAAA;EACA,SAAA;AAEN;AACI;EACE,kBAAA;EACA,YAAA;EACA,SAAA;AACN;AAEI;EACE,kBAAA;EACA,qBAAA;EACA,YAAA;EACA,SAAA;AAAN;AAIE;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;AAFJ;;AAMA;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,cCnES;ADgEX;AAKE;EACE,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AAHJ;AAME;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;AAJJ;;AAQA;EACE,iBAAA;AALF;;AAQA;EACE,aAAA;EACA,gBAAA;AALF;;AAQA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AALF;AAOE;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cCxGO;ADmGX;;AASA;EACE,aAAA;EACA,qBAAA;AANF;AAQE;EACE,WAAA;EACA,qBAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,mDAAA;EACA,sBAAA;EACA,mBAAA;EACA,0BAAA;AANJ;;AAUA;EACE,cAAA;EACA,eAAA;AAPF;;AAUA;EACE,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cCtIU;AD+HZ;;AAUA;EACE;IACE,WAAA;EAPF;EAUA;IACE,mBAAA;EARF;EAWA;IACE,WAAA;IACA,mBAAA;EATF;AACF","sourcesContent":["@use 'styles/colors.scss';\n@use 'styles/sizes.scss';\n\n.title {\n  width: 110%;\n  margin: 0 auto 28px;\n}\n\n.cards {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  width: 100%;\n}\n\n.price {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  padding: 20px;\n  border-radius: 12px;\n  background: colors.$primary4;\n  color: #fff;\n\n  &-description {\n    font-weight: 400;\n    font-size: 20px;\n    line-height: 36px;\n  }\n\n  &-month {\n    position: relative;\n    font-weight: 400;\n    font-size: 28px;\n    line-height: 48px;\n\n    span {\n      font-weight: 600;\n      font-size: 52px;\n      line-height: 84px;\n    }\n\n    .star-left {\n      position: absolute;\n      left: -20px;\n      top: 14px;\n    }\n\n    .star-right {\n      position: absolute;\n      right: -25px;\n      top: 27px;\n    }\n\n    .star-small {\n      position: absolute;\n      transform: scale(0.4);\n      right: -31px;\n      top: 38px;\n    }\n  }\n\n  &-year {\n    font-weight: 300;\n    font-size: 14px;\n    line-height: 24px;\n  }\n}\n\n.product {\n  padding: 20px;\n  border-radius: 12px;\n  background: #fff;\n  color: colors.$primary8;\n\n  &-title {\n    margin-bottom: 12px;\n    font-weight: 400;\n    font-size: 20px;\n    line-height: 36px;\n  }\n\n  &-description {\n    font-weight: 300;\n    font-size: 16px;\n    line-height: 28px;\n  }\n}\n\n.logo {\n  margin-right: 8px;\n}\n\n.collapsible-card {\n  padding: 20px;\n  background: #fff;\n}\n\n.list {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  font-weight: 300;\n  font-size: 16px;\n  line-height: 28px;\n\n  &-title {\n    font-weight: 400;\n    font-size: 20px;\n    line-height: 36px;\n    color: colors.$primary8;\n  }\n}\n\n.item {\n  display: flex;\n  align-items: baseline;\n\n  &:before {\n    content: '';\n    display: inline-block;\n    width: 17px;\n    min-width: 17px;\n    height: 17px;\n    margin-right: 10px;\n    background: url(../../../assets/checkbox-circle.svg);\n    background-size: cover;\n    vertical-align: top;\n    transform: translateY(4px);\n  }\n}\n\n.button {\n  margin: 40px 0;\n  padding: 0 24px;\n}\n\n.link {\n  width: 360px;\n  text-align: center;\n  font-weight: 300;\n  font-size: 16px;\n  line-height: 28px;\n  color: colors.$primary11;\n}\n\n@media screen and (max-width: sizes.$breakpoint-sm) {\n  .title {\n    width: 100%;\n  }\n\n  .button {\n    margin: 32px 0 24px;\n  }\n\n  .link {\n    width: 100%;\n    text-align: initial;\n  }\n}\n","$primary1: #f5f5ff;\n$primary2: #d8d8ff;\n$primary3: #8686ff;\n$primary4: #4343ff;\n$primary5: #1414ff;\n$primary6: #0000c9;\n$primary7: #000093;\n$primary8: #00007a;\n$primary9: #000054;\n$primary10: #00003a;\n$primary11: #000078;\n$blueLogo: #000093;\n\n$neutral1: #fcfcfd;\n$neutral2: #f9f9fa;\n$neutral4: #e0e0e3;\n$neutral8: #838390;\n\n$success1: #f4fced;\n$success5: #58b441;\n$success6: #126f0e;\n\n$attention1: #fef9f0;\n$attention3: #fbd298;\n$attention5: #e78d3d;\n$attention7: #b94402;\n\n$danger1: #fdf1ed;\n$danger2: #f9d9cf;\n$danger3: #f4ada1;\n$danger5: #bd454a;\n$danger6: #911727;\n$danger7: #7c1028;\n\n\n$colabelNeutralLight: #F9F9FA;\n$colabelNeutralMid: #C3C3C9;\n$colabelNeutralDark: #121217;\n\n:export {\n    colabelNeutralLight: $colabelNeutralLight;\n    colabelNeutralMid: $colabelNeutralMid;\n    colabelNeutralDark: $colabelNeutralDark;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"colabelNeutralLight": `#F9F9FA`,
	"colabelNeutralMid": `#C3C3C9`,
	"colabelNeutralDark": `#121217`,
	"title": `SubscriptionMain_title__EDP3Z`,
	"cards": `SubscriptionMain_cards__8FTgc`,
	"price": `SubscriptionMain_price__h8ZeZ`,
	"price-description": `SubscriptionMain_price-description__dt5mj`,
	"price-month": `SubscriptionMain_price-month__FK4Lu`,
	"star-left": `SubscriptionMain_star-left__Sp8AR`,
	"star-right": `SubscriptionMain_star-right__xVZur`,
	"star-small": `SubscriptionMain_star-small__oWSCZ`,
	"price-year": `SubscriptionMain_price-year__fiFDf`,
	"product": `SubscriptionMain_product__kemGf`,
	"product-title": `SubscriptionMain_product-title__9WmQj`,
	"product-description": `SubscriptionMain_product-description__B-ks+`,
	"logo": `SubscriptionMain_logo__3mH52`,
	"collapsible-card": `SubscriptionMain_collapsible-card__iIVJt`,
	"list": `SubscriptionMain_list__MOunc`,
	"list-title": `SubscriptionMain_list-title__EysMS`,
	"item": `SubscriptionMain_item__y8rMH`,
	"button": `SubscriptionMain_button__V+pe6`,
	"link": `SubscriptionMain_link__Qe5km`
};
export default ___CSS_LOADER_EXPORT___;
